enum Indexation {
  None = 'None',
  Honorary = 'Honorary',
  Performances = 'Performances',
}

export default Indexation;
